module.exports = [{"id":1,"menu_ad":"Ana Sayfa","menu_icon":"","router_to":"/"},{"id":2,"menu_ad":"Hakkımızda","menu_icon":"","router_to":"/Hakkimizda"},{"id":3,"menu_ad":"GALERİ","menu_icon":"","router_to":"/Galeri"},{"id":4,"menu_ad":"Sıkça Sorulan Sorular","menu_icon":"","router_to":"/SSS"},{"id":5,"menu_ad":"İLETİŞİM","menu_icon":"","router_to":"/Iletisim"}]


//////////////////
// WEBPACK FOOTER
// ./src/menus.json
// module id = 100
// module chunks = 0